// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__28vwa","col":"styles_col__11LLu"};